module.exports = __webpack_public_path__ + "img/ametista.8cf18fcf.png";